<header class="header-fallback" [ngClass]="{ 'has-open': openUserItem !== null, 'force-white' : openUserItem !== null && (openUserItem !== 'menu' && isDesktop) }" *ngIf=!headerLoading>
  <div class="header-fallback__left">
    <a (click)="INDRA_handleItemClick('/booking', null)"  [attr.aria-label]="'header.aria.goToHomepage'|ibeadmin|async" role="button">
      <app-svg class="header-logo" svg="{{TAP_getLogo()}}"[alt]="'TAP Air Portugal logo'"></app-svg>
    </a>
  </div>

  <div class="header-menu-items-box">
    <ul class="header-fallback__items-wrapper">
      <li class="header-fallback__item" *ngFor="let item of headerItems"  [ngClass]="{ 'is-active': INDRA_isActiveRouter(item)}" (click)="INDRA_handleItemClick(item.link, item)">
        <a tabindex="0" [ngClass]="{ 'is-active': INDRA_isActiveRouter(item)}" [attr.aria-label]="item.aria | ibeadmin | async" role="button">
          <span skeletonLoader [translationKey]="item.label">{{ item.label | ibeadmin | async }}</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="header-menu-box" >
    <div class="header-fallback__right">
      <div class="header-fallback__user" [ngClass]="{ 'is-open': openUserItem === 'user-info' }">
        <a class="header-fallback__action" (click)="INDRA_handleUserClick('user-info')" [attr.aria-label]="INDRA_printUserAriaLabel()" tabindex="0" href="javascript:;" role="button">
          <div class="header-fallback__user-info" [ngClass]="{'logged-in': userLoggedIn}">
            <span class="header-fallback__user-name" *ngIf="userLoggedIn; else iconLog">
              {{userInfo.initials}}
            </span>
            <ng-template #iconLog>
              <app-svg class="header-fallback__icon" svg="icons.svg#general--person"
                [alt]="'User account icon'" aria-hidden="true"></app-svg>
            </ng-template>
          </div>
        </a>
        <div class="header-fallback__open-content" *ngIf=userLoggedIn>
          <h3 class="title-h3" tabindex="0">{{userInfo.name}}</h3>
          <div *ngIf="userInfo.number" class="header-fallback__user-input" tabindex="0" [attr.aria-label]="('header.aria.yourMilesAndGoNumber' | ibeadmin | async) + userInfo.number">
            <span
              class="header-fallback__user-label"
              skeletonLoader
              [translationKey]="'header.text.number'"
              >
              {{'header.text.number' | ibeadmin | async}}
            </span>
            <span class="header-fallback__user-value">{{userInfo.number}}</span>
          </div>
          <div *ngIf="userInfo.status" class="header-fallback__user-input" tabindex="0" [attr.aria-label]="('header.aria.yourCurrentStatus' | ibeadmin | async) + INDRA_printStatusAriaLabel()">
            <span class="header-fallback__user-label">{{'header.text.status' | ibeadmin | async}}</span>
            <app-svg 
              class="header-fallback__user-logo 
              header-fallback__user-logo--{{userInfo.status.toLowerCase()}}" 
              svg="sprite.svg#{{INDRA_printStatusLogo()}}" 
              [attr.aria-label]="INDRA_printStatusAriaLabel() + 'logo'" 
              [alt]="INDRA_printStatusAriaLabel() + 'logo'">
            </app-svg>
          </div>
          <div *ngIf="userInfo.miles" class="header-fallback__user-input" tabindex="0" [attr.aria-label]="('header.aria.youHave' | ibeadmin | async) + userInfo.miles + ' miles'">
            <span
              class="header-fallback__user-label"
              skeletonLoader
              [translationKey]="'header.text.milesBalance'"
              >
              {{'header.text.milesBalance' | ibeadmin | async}}
            </span>
            <span class="header-fallback__user-value">{{ userInfo.miles | indracurrency : 'miles' }}</span>
          </div>
          <div *ngIf="userInfo.clubTap" class="header-fallback__user-input" tabindex="0" [attr.aria-label]="('header.aria.clubStatus' | ibeadmin | async) + INDRA_printClubStatusAriaLabel()">
            <span
              class="header-fallback__user-label"
              skeletonLoader
              [translationKey]="'header.text.clubMilesAndGo'"
              >
              {{'header.text.clubMilesAndGo' | ibeadmin | async}}
            </span>
            <app-svg 
              class="header-fallback__club-logo header-fallback__club-logo--{{ INDRA_printClubLogoClass() }}"
              svg="sprite.svg#{{INDRA_printClubLogo()}}"
              [attr.aria-label]="INDRA_printClubStatusAriaLabel() + 'logo'" 
              [alt]="INDRA_printClubStatusAriaLabel() + 'logo'">
            </app-svg>
            <span class="header-fallback__user-value">
              <span
                class="header-fallback__user-sublabel"
                skeletonLoader
                [translationKey]="'header.text.expDate'"
                >
                {{'header.text.expDate' | ibeadmin | async}}
              </span>
              {{ userInfo.clubTapExpireDate }}
            </span>
          </div>
          <!-- note: from post sprint 8 merge
<button *ngIf="(isCorporate$|async)===false" class="button full-width" *ngIf="INDRA_showLogout()" (click)=INDRA_handleLogout() aria-label="Logout your current session">Logout</button>
          -->
          <button class="button full-width" *ngIf="INDRA_showLogout()" (click)=INDRA_handleLogout()  [attr.aria-label]="'header.aria.logoutSession' | ibeadmin | async">
            <span skeletonLoader [translationKey]="'header.text.logOut'">
              {{'header.text.logOut' | ibeadmin | async}}
            </span>
          </button>
        </div>
      </div>

      <!-- note: from post sprint 8 merge
<div class="header-fallback__user" [ngClass]="{ 'is-open': openUserItem === 'user-info' }" *ngIf="(isCorporate$|async) === true">
<a class="header-fallback__action" (click)="TAP_handleUserClick('user-info')" [attr.aria-label]="TAP_printUserAriaLabel()" tabindex="0" href="javascript:;" role="button">
<app-svg class="header-fallback__icon" svg="icons.svg#general--user_2" [alt]="'User account icon'" aria-hidden="true"></app-svg>
<div class="header-fallback__user-info" *ngIf=userLoggedIn>
<span class="header-fallback__user-name">SONAE | L321</span>
</div>
<div class="header-fallback__user-info" *ngIf=!userLoggedIn>
<span class="header-fallback__user-name">Login</span>
</div>
<app-svg class="header-fallback__icon header-fallback__icon--arrow" svg="icons.svg#general--arrow--bottom" [alt]="'Arrow bottom icon'" aria-hidden="true"></app-svg>
</a>
<div class="header-fallback__open-content" *ngIf=userLoggedIn>
<h3 class="title-h3" tabindex="0">SONAE</h3>
<div *ngIf="userInfo.frequentFlyer" class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'Your current status is ' + TAP_printStatusAriaLabel()">
<app-svg class="header-fallback__user-logo header-fallback__user-logo--{{userInfo.frequentFlyer.tierLevel}}" svg="sprite.svg#{{TAP_printStatusLogo()}}" [attr.aria-label]="TAP_printStatusAriaLabel() + 'logo'" [alt]="TAP_printStatusAriaLabel() + 'logo'"></app-svg>
</div>
<div class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'Your cliente number is: L321'">
<span class="header-fallback__user-label">CIP number</span>
<span class="header-fallback__user-value">L321</span>
</div>
<div class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'Your IATA is 543321'">
<span class="header-fallback__user-label">IATA</span>
<span class="header-fallback__user-value">543321</span>
</div>
<div class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'You have 230002 EUR'">
<span class="header-fallback__user-label">Balance</span>
<span class="header-fallback__user-value">230002 EUR</span>
</div>
<hr class="separator separator--muted bottom-gap">
<div>
<div class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'Switch to Continente'">
<a class="link"  href="javascript:;">Switch to Continente</a>
</div>
<div class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'Switch to Worten'">
<a class="link"  href="javascript:;">Switch to Worten</a>
</div>
<div class="header-fallback__user-input" tabindex="0" [attr.aria-label]="'Switch to Welss'">
<a class="link"  href="javascript:;">Switch to Wells</a>
</div>
</div>
</div>
</div>
      -->

      <div class="header-fallback__country" [ngClass]="{ 'is-open': openUserItem === 'country', 'not-landing': !isLandingPage }" *ngIf="showCountry" 
        [ngStyle]="{'pointer-events': !INDRA_isVisible() ? 'none' : 'auto'}">
        <a class="header-fallback__action" 
          *ngIf="isLandingPage"
          (click)="INDRA_handleUserClick('country')" 
          [attr.aria-label]="'header.aria.changeCountry'|ibeadmin|async" 
          tabindex="0" 
          href="javascript:;" 
          role="button" 
          aria-haspopup="listbox" 
          [attr.aria-expanded]="openUserItem === 'country'">
          <app-svg class="header-fallback__country-flag"
            svg="sprite.svg#{{countriesList[selectedCountryIndex].image}}"
            [alt]="countriesList[selectedCountryIndex].country + ' flag'" aria-hidden="true"
            *ngIf="showCountryFlag"></app-svg>
        </a>
        <div *ngIf="!isLandingPage" class="header-fallback__action header-fallback__options_close"
          [attr.aria-label]="'header.aria.changeCountry'|ibeadmin|async" tabindex="0" [attr.aria-expanded]="openUserItem === 'country'">
          <app-svg class="header-fallback__country-flag"
            svg="sprite.svg#{{countriesList[selectedCountryIndex].image}}"
            [alt]="countriesList[selectedCountryIndex].country + ' flag'" aria-hidden="true"
            *ngIf="showCountryFlag"></app-svg>
        </div>
        <div class="header-fallback__open-content">
          <ul class="header-fallback__countries-list" [attr.aria-label]="'header.aria.listOfCountries'|ibeadmin|async" role="listbox">
            <li class="header-fallback__country-item"
              [ngClass]="{ 'is-active': selectedCountryIndex === index }"
              (click)="INDRA_handleCountryClick(country.code, index)"
              *ngFor="let country of countriesList; let index = index" role="option"
              [attr.aria-selected]="selectedCountryIndex === index">
              <app-svg class="header-fallback__country-flag"
                svg="sprite.svg#{{countriesList[index].image}}"
                [alt]="countriesList[index].country + ' flag'" aria-hidden="true"></app-svg>
              <span class="header-fallback__country-label">{{countriesList[index].country}}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="header-fallback__language" [ngClass]="{ 'is-open': openUserItem === 'language', 'not-landing': !isLandingPage }" 
        [ngStyle]="{'pointer-events': !INDRA_isVisible() ? 'none' : 'auto'}">
        <a  *ngIf="isLandingPage" class="header-fallback__action" (click)="INDRA_handleUserClick('language')" 
          [attr.aria-label]="'header.aria.changeLanguage'|ibeadmin|async" 
          tabindex="0" 
          href="javascript:;" 
          role="button" 
          aria-haspopup="listbox" 
          [attr.aria-expanded]="openUserItem === 'language'">
          <span
            class="header-fallback__language-label"
            skeletonLoader
            [translationKey]="languageList && languageList[selectedLanguageIndex] ? languageList[selectedLanguageIndex].label : ''"
          >
            {{ INDRA_getLanguageCode() }}
          </span>
        </a>
        <div *ngIf="!isLandingPage" class="header-fallback__action"  
          [attr.aria-label]="'header.aria.changeLanguage'|ibeadmin|async" 
          tabindex="0" 
          href="javascript:;" 
          role="button" 
          aria-haspopup="listbox" 
          [attr.aria-expanded]="openUserItem === 'language'">

          <span
            class="header-fallback__language-label"
            skeletonLoader
            [translationKey]="languageList && languageList[selectedLanguageIndex] ? languageList[selectedLanguageIndex].label : ''"
          >
            {{(languageList &&
            languageList[selectedLanguageIndex] ?
            languageList[selectedLanguageIndex].label : "") |ibeadmin|async}}
          </span>
        </div>

        <div class="header-fallback__open-content">
          <ul class="header-fallback__languages-list" 
            [attr.aria-label]="'header.aria.listOfLanguage'|ibeadmin|async" 
            tabindex="0" 
            role="listbox" 
            role="option" 
            [attr.aria-selected]="selectedLanguageIndex === index">

            <li class="header-fallback__country-item" (click)="INDRA_handleLanguageClick(language.code, index)"
              *ngFor="let language of languageList; let index = index">
              <a  
                [attr.aria-label]="('header.aria.changeTo' |ibeadmin|async) + (language.label|ibeadmin|async)"
                tabindex="0" 
                href="javascript:;" 
                role="button">

                <span
                  class="header-fallback__language-label" 
                  [ngClass]="{ 'is-active': selectedLanguageIndex === index }"
                  skeletonLoader
                  [translationKey]="language.label"
                >	
                  {{ INDRA_getCountryTranslation(language.label) | async }}
                </span>

              </a>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <div class="header-fallback__menu" [ngClass]="{ 'is-open': openUserItem === 'menu' }">
      <a class="header-fallback__action header-fallback__action--hamburger" (click)="INDRA_handleUserClick('menu')" tabindex="0" [attr.aria-label]="'header.aria.openMenu' | ibeadmin | async" href="javascript:;" role="button">
        <lottie-animation-view class="header-fallback__icon"
          [attr.aria-label]="'header.aria.menuIcon' | ibeadmin | async" role="button" tabindex="0" [options]="lottieConfigHamburgerMenu"
          (animCreated)="handleHamburgerMenuAnimation($event)">
        </lottie-animation-view>
      </a>

      <div class="header-fallback__open-content" >
        <ul class="fallback__menu-box">
          <li class="menu-items" *ngFor="let item of headerItems" (click)="INDRA_handleItemClick(item.link, item)" >
            <a tabindex="0" 
              [ngClass]="{ 'is-active': INDRA_isActiveRouter(item)}" 
              [attr.aria-label]="item.aria | ibeadmin| async" 
              href="javascript:;" 
              role="button">
              {{ item.label | ibeadmin | async}}
            </a>
          </li>
          <li class="menu-items" (click)="INDRA_openMarketLanguageSidebar()">
            <div class="header-fallback__market-wrapper"
              *ngIf="showCountry && !isDesktop && isLandingPage">
              <app-svg class="header-fallback__country-flag"
                svg="sprite.svg#{{countriesList[selectedCountryIndex].image}}"
                [alt]="countriesList[selectedCountryIndex].country + ' flag'" 
                aria-hidden="true"
                *ngIf="showCountryFlag"></app-svg>
              <span class="header-fallback__market-label">{{countriesList[selectedCountryIndex].country}} / {{(countriesList[selectedCountryIndex] &&
                countriesList[selectedCountryIndex].language &&
                countriesList[selectedCountryIndex].language[selectedLanguageIndex]	?
                countriesList[selectedCountryIndex].language[selectedLanguageIndex].label : "") |ibeadmin|async }}</span>
            </div>
            <div class="header-fallback__market-wrapper"
              *ngIf="showCountry && !isDesktop && !isLandingPage">
              <app-svg class="header-fallback__country-flag"
                svg="sprite.svg#{{countriesList[selectedCountryIndex].image}}"
                [alt]="countriesList[selectedCountryIndex].country + ' flag'" aria-hidden="true"
                *ngIf="showCountryFlag"></app-svg>
              <span class="header-fallback__market-label">{{countriesList[selectedCountryIndex].country}} / {{(countriesList[selectedCountryIndex] &&
                countriesList[selectedCountryIndex].language &&
                countriesList[selectedCountryIndex].language[selectedLanguageIndex]	?
                countriesList[selectedCountryIndex].language[selectedLanguageIndex].label : "") |ibeadmin|async }}</span>
            </div>
          </li>
        </ul> 
      </div>
    </div>
  </div>

  <div class="header-fallback__overlay" [ngClass]="{ 'is-open': openUserItem !== null, 'is-hamburger': openUserItem === 'menu' }" (click)="INDRA_handleClose()"></div>

  <app-nlf-login-dropdown *ngIf="!userLoggedIn && isLandingPage && nlfLoginDropdownEnabled"></app-nlf-login-dropdown>
</header>
